import { ChangeDetectorRef, Component } from '@angular/core';
import { FileService } from 'src/app/services/file.service';
import { ModalService } from 'src/app/services/modal.service';

declare function setReadonlyOnInputsToState(readonlyState: boolean, isForced: boolean): void;
declare function openCameraWithID(inputID: string): void;
declare function makeToast(message: string): void;

@Component({
  selector: 'app-attachments',
  templateUrl: './attachments.component.html',
  styleUrls: ['./attachments.component.css']
})
export class AttachmentsComponent {

  currentData = this.modalService.getModalData();
  burialDocs = this.currentData.burialDocs;
  deathType = this.modalService.currentDeathType();
  private takeImageOptions?: string;

  constructor(private modalService: ModalService,
    private fileService: FileService,
    private changeDetectorRef: ChangeDetectorRef) { }

  ngAfterViewInit() {
    setReadonlyOnInputsToState(false, false);
  }

  takeImageClicked(documentID: string) {
    /** Erlaubnis zur Einäscherung (dok_todesbescheinigung_ga): nur Anzeige, kein Upload */
    if (documentID === 'deathapproval') {
      const imageBaseString = this.burialDocs.deathapprovalData;
      if (imageBaseString) {
        window.open(imageBaseString, '_blank');
      } else {
        makeToast('Die Erlaubnis zur Einäscherung ist hier nur zur Ansicht verfügbar und wird vom Krematorium bereitgestellt, sobald sie vorliegt.');
      }
      return;
    }

    if (documentID === 'deathapprovalsecret') {
      this.takeImageOptions = documentID;
      openCameraWithID('takePictureField');
      return;
    }

    var imageBaseString = null;

    if (this.burialDocs.hasOwnProperty(documentID + 'Data')) {
      imageBaseString = this.burialDocs[documentID + 'Data'];
    }

    if (imageBaseString && confirm('Dokument bereits vorhanden, mit OK wird das vorhandene Dokument angezeigt, mit Abbrechen kann ein neues Dokument gespeichert werden')) {
      window.open(imageBaseString, '_blank');
    } else {
      this.takeImageOptions = documentID;
      openCameraWithID('takePictureField');
    }
  }

  takeImageCallback(fieldID: string) {
    const elementWithFieldId: any = document.getElementById(fieldID);
    if (!elementWithFieldId) { return; }

    var imageField = elementWithFieldId.files[0];
    var fileReader = new FileReader();

    var that = this;
    fileReader.onloadend = function (readResult: any) {
      var documentID = that.takeImageOptions + 'Data';
      var imageString = readResult.target.result;
      elementWithFieldId.value = '';

      if (documentID && imageString) {
        that.fileService.convertImagesToPDF(imageString, function (imageStringConverted: string) {
          that.burialDocs[documentID] = imageStringConverted;
          that.modalService.didInputForClass(documentID);
          that.modalService.setModalData('burialDocs', that.burialDocs);
        });

        that.changeDetectorRef.detectChanges();
        makeToast('Bild gespeichert');
      } else {
        makeToast('Fehler beim Speichern des Dokuments, bitte erneut versuchen');
      }
    };

    fileReader.onerror = function () {
      elementWithFieldId.value = '';
      makeToast('Fehler beim Laden des Dokuments, bitte erneut versuchen')
    };

    fileReader.readAsDataURL(imageField);
  }

}
